'use client';

const overlayFgColorAttr = "data-fg-color";
const hoverOverlays = {
  onDarkWithDarkFg: ["rgba(255,255,255, 0.2)", "rgba(74, 110, 183, 0.05)"],
  onDarkWithLightFg: ["rgba(255,255,255, 0.1)", "rgba(40, 45, 55, 0.2)"],
  onLightWithDarkFg: ["rgba(74, 110, 183, 0.05)", "rgba(255, 255, 255, 0.2)"],
  onLightWithLightFg: ["rgba(40, 45, 55, 0.2)", "rgba(255, 255, 255, 0.1)"]
};
const hoverOverlayVar = "--chalk-button-overlay-hover";
const pressedOverlays = {
  onDarkWithDarkFg: ["rgba(255,255,255, 0.4)", "rgba(74, 110, 183, 0.1)"],
  onDarkWithLightFg: ["rgba(255,255,255, 0.15)", "rgba(40, 45, 55, 0.4)"],
  onLightWithDarkFg: ["rgba(93, 111, 156, 0.1)", "rgba(255, 255, 255, 0.4)"],
  onLightWithLightFg: ["rgba(40, 45, 55, 0.4)", "rgba(255, 255, 255, 0.15)"]
};
const pressedOverlayVar = "--chalk-button-overlay-pressed";
export {
  hoverOverlayVar,
  hoverOverlays,
  overlayFgColorAttr,
  pressedOverlayVar,
  pressedOverlays
};
